// API連携（W2 OpenAPI 送信・ターゲットリスト）API パス・型
// 対応ルーター: backend/routers/w2_integration.py

export const W2IntegrationApiPath = {
  LIST_TARGET_LISTS: '/api/sites/{site_id}/target-lists',
  LIST_TARGET_LIST_ITEMS: '/api/sites/{site_id}/target-lists/{tl_id}/items',
  W2_SEND_STATUS: '/api/sites/{site_id}/w2-send-status',
  SEND_ONE: '/api/sites/{site_id}/target-list-items/{item_id}/send',
  SEND_BULK: '/api/sites/{site_id}/target-lists/{tl_id}/send'
} as const

export type W2IntegrationApiPath =
  (typeof W2IntegrationApiPath)[keyof typeof W2IntegrationApiPath]

// --- ターゲットリスト一覧 ---
export interface TargetList {
  id: number
  target_list_id: string
  target_name: string
  target_type: string
  exec_timing: string
  data_count: number | null
  last_sent_at: string | null
  total: number
  unsent: number
  sent: number
  error: number
}

export interface ListTargetListsVars {
  site_id: number
}
export type ListTargetListsResponse = TargetList[]

// --- アイテム一覧 ---
export interface TargetListItem {
  id: number
  target_list_id: number
  user_id: string
  send_status: string // unsent / sent / error
  error_message: string | null
  sent_at: string | null
}

export interface ListTargetListItemsVars {
  site_id: number
  tl_id: number
}
export type ListTargetListItemsResponse = TargetListItem[]

// --- W2Commerce送信データ状況 ---
export interface W2SendStatusRow {
  target_list_id: number
  name: string
  w2_target_list_id: string
  total: number
  unsent: number
  sent: number
  error: number
  last_sent_at: string | null
}

export interface W2SendStatus {
  enabled: boolean
  target_list_enabled: boolean
  rows: W2SendStatusRow[]
  total_items: number
  total_sent: number
  total_unsent: number
  total_error: number
}

export interface GetW2SendStatusVars {
  site_id: number
}
export type GetW2SendStatusResponse = W2SendStatus

// --- 送信 ---
export interface SendResult {
  ok: boolean
  sent: number
  failed: number
  message: string
}

export interface SendOneVars {
  site_id: number
  item_id: number
}

export interface SendBulkVars {
  site_id: number
  tl_id: number
  scope?: 'unsent' | 'all'
}

export type SendResultResponse = SendResult
